import { getConfigValues } from 'src/config';
import Routes from 'src/config/routes';

const shareMarketplaceInsightsLandingPageEmail = {
  subject: encodeURIComponent(
    "I thought you'd like this report to stay ahead of the curve!",
  ),
  body: encodeURIComponent(`Hey,

I thought you’d be interested in this Marketplace Industry Report from SEEK Business.
  
It offers a comprehensive analysis of past and emerging trends in the business-for-sale market, and features special commentary from Warren Hogan, Chief Economist at Judo Bank.
  
Following a year of record-breaking enquiry volumes in 2023, buyer enquiries on SEEK Business increased 16% year on year, which underscores a shifting landscape where business ownership is increasingly seen as an attractive career path.
  
Warren's expertise sheds light on the resilience of the Australian business sector and the underlying factors propelling interest in small business ownership.
  
Access the full report here: ${getConfigValues().HEADER_SERVER_BASE}${
    Routes.MARKETPLACE_INSIGHTS
  }`),
};

export const shareInsightsReportEmailHref = `mailto:?subject=${shareMarketplaceInsightsLandingPageEmail.subject}&body=${shareMarketplaceInsightsLandingPageEmail.body}`;
